/**
 * @description 新闻
 */
export default [{
  path: '/news/info', //新闻内容
  name: 'news_info',
  component: () => import('../../views/news/Info.vue'),
  meta: {
    title: '新闻详情-油柑网',
    bodyColor: true
  }
}]